
import dayjs from 'dayjs'
import i18n from '@/locales/index'

export const columns = [
  {
    title: 'actions',
    dataIndex: 'actions',
    ellipsis: true,
  },
  {
    title: 'page_my_document_filenm',
    dataIndex: 'name',
    ellipsis: true,
    scopedSlots: { customRender: 'name' }
  },
  {
    title: 'page_my_document_size',
    dataIndex: 'contentLength',
    width: 108,
    ellipsis: true,
    scopedSlots: { customRender: 'contentLength' }
  },
  {
    title: 'page_my_document_type',
    dataIndex: 'fileType',
    width: 128,
    key: 'fileType',
    customRender: (text) => {
      return text == 1 ? i18n.t('page_my_document_program') : i18n.t('page_my_document_process')
    }
  },
  {
    title: 'page_transport_directory_upload_time',
    dataIndex: 'lastModified',
    key: 'lastModified',
    width: 188,
    ellipsis: true,
    customRender: (text) => {
      return text ? dayjs(text).format('YYYY-MM-DD HH:mm:ss') : ''
    }
  }
]
